// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableWithSortPagtnWithTot";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import { Table, Checkbox } from "semantic-ui-react";
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours=0;
let sumbillable=0;
let maxwidth="80vw";
const ListPresentList = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    disablePagination
  }) => {
    const [thead] = useState([
      "Date",
      "Project",
      "Employee",
      "Task",
      "Description",
      "Estimated Hours",
       "Hours Spent",
       "Hours Billable",
      //  "Leave Type",
       "Status",
       

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
   
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

   

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);


    return (
      <Fragment>
        <div className="fixed-header">
          <div>
         <h4>Work Summary</h4>
            &nbsp;
          
            <div className="d-inline float-right ">
           
            </div>
          </div>
        </div>
        <div className="" style={{ maxWidth: maxwidth, overflowY: disablePagination ? "visible !important" : "auto", maxHeight: disablePagination ? "auto !important" : "80vh" }}>
     {empTask.map((employeeData) =>{
      <Table bordered>
          <thead className="bg-primary text-white">
            <tr>
              <th>Employee ID: {employeeData.employeeID}</th>
              <th>Name: {employeeData.employeeName}</th>
              <th>Department: {employeeData.departmentName}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {employeeData.attendance.map((date, index) => (
                <td key={index} className="bg-light text-center p-2">
                  <strong>{date}</strong>
                  <div>Fullday - Work from home [Present]</div>
                  <small>Wd: 00:00:00</small>
                </td>
              ))}
            </tr>
          </tbody>
        </Table>
     })}   
    </div>
     
      </Fragment>
    );
  }
);

export default ListPresentList;
